import { isContentHubLicense } from '@celum/authentication';
import { Account } from '@celum/sacc/domain';

export function hasContentCustomSpecificationLicense(account: Account): boolean {
  return account?.licenses?.find(isContentHubLicense)?.customSpecificationAvailable;
}
